<form [formGroup]="form">
  <div class="row">
    <div class="col-12">
      <app-custom-input id="firstName" type="text"
                        [label]="'NAME_DATA.FIRSTNAME' | translate"
                        [customFormGroup]="form"
                        [noteText]="'NAME_DATA.FIELD_ERROR.REQUIRED' | translate"
                        [attr.data-cy]="testIdPrefix + 'firstname'">
      </app-custom-input>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <app-custom-input id="lastName" type="text"
                        [label]="'NAME_DATA.LASTNAME' | translate"
                        [customFormGroup]="form"
                        [noteText]="'NAME_DATA.FIELD_ERROR.REQUIRED' | translate"
                        [attr.data-cy]="testIdPrefix + 'lastname'">
      </app-custom-input>
    </div>
  </div>
</form>
